var MobileMode;
(function (MobileMode) {
  MobileMode["Auto"] = "auto";
  MobileMode["Enable"] = "enable";
  MobileMode["Disable"] = "disable";
})(MobileMode || (MobileMode = {}));
var MobileMode$1 = MobileMode;

export { MobileMode$1 as M };
//# sourceMappingURL=MobileMode-ef55d00f.js.map
